/* HÄUFIGE WARTEGRÜNDE OBEN, FREITEXT ZUM ANTIPPEN (.450).
   ORIGINALTEXT MARVIN (22.10.2026)
     „wo holt sicht das system den freitext her? hier sind die gängigen
      einträge: CT: Bauverhinderung #0102# Trasse nicht durchgängig, #0104#
      Verhinderung durch Dritte, #0105# durch Kommune/Stadt/Gemeinde; Kunde
      nicht erreichbar #0301#; Eigentümer nicht erreichbar #0401#. BULK:
      Bauverhinderung #5102#, #5104#, #5105#; Eigentümer nicht erreicht"
     und: „ja das sind tippfehler ... ja setze beide vorschläge um."
   Die Nummern kommen aus dem Telekom-Katalog (katalog.ts): #0301# ist „Kunde
   nicht erreicht", Eigentümer am Bulk-Standort ist #5401#. Die Vorschläge für
   den Freitext sind Bausteine; was im Feld steht, kann man vor dem Absenden
   ändern. Keine Preise, keine Namen. */

export const HAEUFIG: Record<'STANDARD' | 'BFO', string[]> = {
  STANDARD: ['0102', '0104', '0105', '0301', '0401', '0801'],
  BFO: ['5102', '5104', '5105', '5401', '5801'],
};
/** Am Bulk-Auftrag (Gebäudeauftrag) hat der Grund keinen Hashtag. */
export const HAEUFIG_BULK = ['Bauverhinderung', 'Eigentümer nicht erreichbar'];

const TRASSE = ['Trasse bis zum Gebäude nicht durchgängig, Tiefbau muss nacharbeiten', 'Leerrohr verstopft oder beschädigt, Klärung läuft'];
const DRITTE = ['Zugang durch Dritte verhindert, Klärung mit dem Beteiligten läuft', 'Arbeiten eines anderen Gewerks blockieren die Trasse'];
const KOMMUNE = ['Verkehrsrechtliche Anordnung der Kommune steht aus', 'Aufbruchgenehmigung der Kommune steht aus', 'Kommune hat die Arbeiten vorläufig untersagt'];
const KUNDE = ['Kunde telefonisch mehrfach nicht erreicht, Rückruf erbeten', 'Kunde vor Ort nicht angetroffen, Benachrichtigung hinterlassen'];
const EIGENTUEMER = ['Eigentümer telefonisch und schriftlich nicht erreicht', 'Eigentümer vor Ort nicht angetroffen, Benachrichtigung hinterlassen'];

/** Vorschläge je Grund des Katalogs (gilt für 0xxx und 5xxx) und je Bulk-Grund. */
const VORSCHLAEGE: Record<string, string[]> = {
  TRENCH_NOT_CONTINUOUS: TRASSE,
  PREVENTION_BY_THIRD_PARTY: DRITTE,
  PREVENTION_BY_AUTHORITIES: KOMMUNE,
  CUSTOMER_NOT_REACHED: KUNDE,
  OWNER_NOT_REACHED: EIGENTUEMER,
  'Bauverhinderung': [...TRASSE, ...DRITTE, ...KOMMUNE],
  'Eigentümer nicht erreichbar': EIGENTUEMER,
};

export function freitextVorschlaege(schluessel: string | null | undefined): string[] {
  return schluessel ? VORSCHLAEGE[schluessel] ?? [] : [];
}

/** Auswahl mit „Häufig" oben; die übrigen Gründe nach Kategorie darunter. */
export function GrundOptionen({ gruende, modus }: { gruende: any[]; modus: 'STANDARD' | 'BFO' }) {
  const oben = HAEUFIG[modus].map((h) => gruende.find((w) => w.hashtag === h)).filter(Boolean);
  const rest = gruende.filter((w) => !HAEUFIG[modus].includes(w.hashtag));
  const kategorien = [...new Set(rest.map((w) => w.kategorie_text))];
  return (
    <>
      {oben.length > 0 && (
        <optgroup label="Häufig">
          {oben.map((w: any) => <option key={'h' + w.hashtag} value={w.hashtag}>#{w.hashtag}# {w.kategorie_text}: {w.grund_text}</option>)}
        </optgroup>
      )}
      {kategorien.map((k) => (
        <optgroup key={k} label={k}>
          {rest.filter((w) => w.kategorie_text === k).map((w) => <option key={w.hashtag} value={w.hashtag}>#{w.hashtag}# {w.grund_text}</option>)}
        </optgroup>
      ))}
    </>
  );
}

export function BulkOptionen({ gruende }: { gruende: string[] }) {
  const oben = HAEUFIG_BULK.filter((g) => gruende.includes(g));
  const rest = gruende.filter((g) => !HAEUFIG_BULK.includes(g));
  return (
    <>
      {oben.length > 0 && <optgroup label="Häufig">{oben.map((g) => <option key={'h' + g} value={g}>{g}</option>)}</optgroup>}
      <optgroup label="Alle weiteren">{rest.map((g) => <option key={g} value={g}>{g}</option>)}</optgroup>
    </>
  );
}

/** Die Bausteine zum Antippen; ein Tipp setzt den Freitext. */
export function FreitextBausteine({ vorschlaege, wert, setze }: { vorschlaege: string[]; wert: string; setze: (t: string) => void }) {
  if (!vorschlaege.length) return null;
  return (
    <div className="reihe freitext-bausteine" style={{ gap: 6, flexWrap: 'wrap', margin: '6px 0 10px' }}>
      {vorschlaege.map((t) => (
        <button key={t} type="button" className={`knopf klein${wert.trim() === t ? ' aktiv' : ''}`} onClick={() => setze(t)}>{t}</button>
      ))}
    </div>
  );
}

/* DIE WIEDERVORLAGE SETZT DER ROBOTER (.462, .463). Marvin, 22.10.2026:
   „so lang setzen, wie es möglich ist, laut dem Handbuch der Telekom".
   Die Frist je Hashtag kommt vom Server (Wartegründe V9.1); statt eines
   Datumsfelds steht hier, was gilt. Ohne gewählten Grund ein Hinweis. */
export function wvZielIso(): string {
  return new Date(Date.now() + 28 * 86_400_000).toISOString().slice(0, 10);
}
export function WvHinweis({ fristen, fristenBulk, hashtag, bulkGrund }: { fristen: Record<string, string> | undefined; fristenBulk?: Record<string, string>; hashtag?: string | null; bulkGrund?: string | null }) {
  const h = (hashtag ?? '').replace(/#/g, '');
  const frist = h ? fristen?.[h] : bulkGrund ? fristenBulk?.[bulkGrund] : undefined;
  return (
    <div className="feld"><label>Wiedervorlage</label>
      <div className="wv-hinweis">
        {frist ? <>Laut Telekom-Handbuch{h ? ` #${h}#` : ''}: <b>{frist}</b>. Der Roboter setzt das späteste erlaubte Datum (ist der Tag gesperrt, den nächsten freien davor) und übernimmt es in unsere Wiedervorlage.</>
          : h || bulkGrund ? <>Für diesen Grund nennt das Handbuch keine Frist; der Roboter setzt 20 Arbeitstage und übernimmt das Datum in unsere Wiedervorlage.</>
          : <>Setzt der Roboter nach dem Telekom-Handbuch, sobald der Grund gewählt ist.</>}
      </div>
    </div>
  );
}
